import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@stores/authStore';
import { useEffect } from 'react';

// Check if the current path is an external authentication path
const isExternalAuthPath = (pathname: string): boolean => {
  const isExternal =
    pathname === '/auth/external-login' ||
    pathname === '/auth/external-register' ||
    // "Continue with Shopify" handoff: already_signed_in / bound / confirm_required /
    // store_change_required all require this page to run while the merchant is
    // still authenticated, so it must not be bounced to '/' before its own code runs.
    pathname === '/auth/shopify';
  console.log('AuthLayout - Checking if path is external auth:', { pathname, isExternal });
  return isExternal;
};

export function AuthLayout() {
  const { isAuthenticated, isIntegrationInProgress } = useAuthStore();
  const location = useLocation();

  // Scroll window to top on route change within auth area
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  // For external auth paths, always allow access
  if (isExternalAuthPath(location.pathname)) {
    console.log('AuthLayout - Allowing external auth path:', location.pathname);
    return (
      <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-green-900">
        <Outlet />
      </div>
    );
  }

  // Redirect to dashboard if already authenticated for non-external auth routes
  if (isAuthenticated && !isIntegrationInProgress) {
    console.log('🔄 AuthLayout - Redirecting authenticated user to dashboard');
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-green-900">
      <Outlet />
    </div>
  );
}
